import React, { FC, FormEvent } from 'react';
import PropTypes from 'prop-types';
import { Button, Input } from 'esa-ui-library';
import { Form } from '..';
import { useStore } from '../../../common';

interface EmailFormProps {
	onSubmit: () => void;
}

const EmailForm: FC<EmailFormProps> = ({ onSubmit }): JSX.Element => {
	const [state, dispatch] = useStore();
	const { email, emailInvalid, errors, success } = state;

	const onEmailChange = (val: string) => {
		dispatch('EMAIL', val);
	};

	const submitHandler = (e: FormEvent<HTMLFormElement>) => {
		e.preventDefault();
		onSubmit();
	};

	return (
		<Form errors={errors} success={success}>
			<form onSubmit={submitHandler}>
				<Input
					type='text'
					label='Email'
					value={email}
					placeholder='Enter your email here'
					dataId='email-field'
					onChange={onEmailChange}
				/>
				<Button type='submit' title='Continue' fluid primary disabled={!email || emailInvalid} dataId='submit-button' />
			</form>
		</Form>
	);
};

EmailForm.propTypes = {
	onSubmit: PropTypes.func.isRequired,
};

export { EmailForm };
